import styles from "./ComingSoon.module.scss";

const ComingSoon = ({ title = "Coming Soon", description = "This section is under construction." }) => {
  return (
    <div className={styles["coming-soon"]}>
      <div className={styles["coming-soon__icon"]}>🚧</div>
      <h2 className={styles["coming-soon__title"]}>{title}</h2>
      <p className={styles["coming-soon__desc"]}>{description}</p>
    </div>
  );
};

export default ComingSoon;
